module.exports = __webpack_public_path__ + "static/media/logo_white.56b7b0cf.svg";